import React, { useState, useCallback, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    cleanObject,
    generateHiddenColumns,
    copyToClipboard,
    hasPermission,
    usersManage,
    usersPermissionOptions,
    createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import { ReactComponent as GreenCircleSvgIcon } from "../../images/GreenCircle.svg";
import { ReactComponent as GrayRectangleSvgIcon } from "../../images/GrayRectangle.svg";
import { ReactComponent as WarningIcon } from "../../images/irm-icon-alert.svg";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Typography } from "@mui/material";
import Table from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import UserPermissionsDialog from "./UserPermissionsDialog";
import axios from 'axios';
import "../pages.scss";
import Ajv from "ajv";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import UsersPropertiesPanel from './UsersPropertiesPanel';
import { usePermissionContext } from "../../contexts/permission-context";


const userSchemaRequired = require("../../json/userSchema.json").create.required;
const userSchemaUpdate = require("../../json/userSchema.json").update;


const ajv = new Ajv({ strict: false });

const uiSchema = {
    "userAuthInfo": {
        "acls": {
            "assets": {
                "ui:options": {
                    orderable: false,
                    addable: false,
                    removable: false
                }
            },
            "users": {
                "ui:options": {
                    orderable: false,
                    addable: false,
                    removable: false
                }
            },
            "platform": {
                "ui:options": {
                    orderable: false,
                    addable: false,
                    removable: false
                }
            },
            "company": {
                "ui:options": {
                    orderable: false,
                    addable: false,
                    removable: false
                }
            }
        }
    }
};



const UserSessionsTabPanel = ({ setNotify, createUserOperation, setOpenUser }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmProps, setConfirmProps] = useState({});

    const [permissionDialogOpen, setPermissionDialogOpen] = useState(false);
    const [userData, setUserData] = useState({});

    const formId = 'UsersDialog';
    const saveButtonText = "Save User";

    const [reload, setReload] = useState(false);

    const [isLoading, setIsloading] = useState(false);

    const [users, setUsers] = usePersistentStorage("users", []);

    useEffect(() => {
        // check if localstorge had data for the current tab
        setApiData(users);
    }, []);


    useEffect(() => {
        if (createUserOperation) {
            createUserData();
        }
    }, [createUserOperation]);

    const apiURL = `api/companies/%COMPANY_ID%/users?`;

    const totalLabel = "Matching Users";

    const fieldData = [
        'userId', 'firstName', 'lastName', 'status',
        'createdDate', 'createdUserId'
    ];

    const hasUsersManage = hasPermission(permissions, usersManage);

    const sortFieldData = [
        {
            field: 'userId',
            label: 'User ID'
        },
        {
            field: 'firstName',
            label: 'First Name'
        },
        {
            field: 'lastName',
            label: 'Last Name'
        },
        {
            field: 'status',
            label: 'Status'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'createdUserId',
            label: 'Created User ID'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     maxWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 160,
            maxWidth: 160,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params)
        },
        {
            hideable:false,
            field: 'userId',
            headerName: 'User ID',
            minWidth: 450,
            //maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (

                    <div className="guidContent">
                        <div style={{ width: '400px', overflow: "hidden", textOverflow: "ellipsis" }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy user ID" onClick={(event) => copyToClipboard(event, params.row.userId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'firstName',
            headerName: 'First Name',
            minWidth: 150,
            //maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: (params) => params.row.userProfile.firstName
        },
        {
            hideable:false,
            field: 'lastName',
            headerName: 'Last Name',
            minWidth: 150,
            //maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: (params) => params.row.userProfile.lastName
        },
        {
            hideable:false,
            field: 'status',
            headerName: 'Status',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                // STATUS - ACTIVE, DISABLED, TERMINATED(don't need to show??)
                if (params.row.userProfile.status === 'ACTIVE') {
                    return (
                        <>
                            <Tooltip arrow title={params.row.userProfile.status} placement="right">
                                <GreenCircleSvgIcon />
                            </Tooltip>
                        </>
                    );
                }

                if (params.row.userProfile.status === 'DISABLED') {
                    return (
                        <>
                            <Tooltip arrow title={params.row.userProfile.status} placement="right">
                                <GrayRectangleSvgIcon />
                            </Tooltip>
                        </>
                    );
                }
            }
        },
        {
            field: 'createdDate',
            headerName: 'Created Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: (params) => params.row.userProfile.createdDate
        },
        {
            field: 'createdUserId',
            headerName: 'Created User ID',
            hide: true,
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: (params) => params.row.userProfile.createdUserId
        }
    ];

    const getColumns = () => {
        return (hasUsersManage && columns) || columns.filter(obj => { return obj.field !== "actions" });
    };

    const toggleColumnPinning = () => {
        return (hasUsersManage && 'columnPinning') || '';
    };


    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        qparams += `&withAuth=true`;

        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                //console.log("Updating table data: ", data);
                setApiData(data);
                setUsers(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
                // live reload changes commented
                // let user = data.find(item => item.userId === "pavan.kumar3@ironmountain.com");
                // console.log(user);
                // let isLoggedinUser = user && user.userId.toLowerCase() === getUser().toLowerCase();
                // console.log(isLoggedinUser);
                // sessionStorage.setItem()
                // sessionStorage.setItem("acls", JSON.stringify(user.userAuthInfo.acls));
                // console.log(hasPermission(companyManage));
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load users data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });
    };

    const transformAcls = (data) => {

        let acls = data.userAuthInfo.acls;
        let platformAcls = [];
        let usersAcls = [];
        let companyAcls = [];
        let assetsAcls = [];

        acls.forEach((acl) => {
            if (acl.permission.startsWith('platform')) {
                platformAcls.push(acl);
            } else if (acl.permission.startsWith('users')) {
                usersAcls.push(acl);
            } else if (acl.permission.startsWith('company')) {
                companyAcls.push(acl);
            } else if (acl.permission.startsWith('assets')) {
                assetsAcls.push(acl);
            }

        });

        data.userAuthInfo.acls = {};  // clear

        // convert to array of objects by type of acls
        data.userAuthInfo.acls['platform'] = platformAcls;
        data.userAuthInfo.acls['users'] = usersAcls;
        data.userAuthInfo.acls['company'] = companyAcls;
        data.userAuthInfo.acls['assets'] = assetsAcls;
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        transformAcls(formattedData);

        setRowJsonData(formattedData);

        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };

    const viewEditData = useCallback((rowData) => () => {
        // console.log("view/edit icon clicked", rowData);

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = rowData;

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        transformAcls(formattedData);

        setRowJsonData(formattedData);

        setMode('edit');
        setReadOnly(false);
        setOpen(true);
    }, []);


    const deleteUser = (companyId, userId, userStatus) => {

        // updateUserStatus(companyId, userId, UserStatus.TERMINATED.name(), "User Removed Manually")

        // The delete user is actually a PUT request to change status to TERMINATED
        //let updateUrl = `/api/companies/${companyId}/users/${userId}`;


        updateUserStatus(companyId, userId, userStatus);


    };

    const deleteUserData = useCallback((rowData) => () => {
        // console.log("delete user icon clicked", rowData);

        let userId = rowData.userId;
        let companyId = rowData.companyId;
        let userStatus = "TERMINATED";

        let title = "Delete User";
        let confirmButtonText = "Delete";

        // "The user [" + item.companyId + ", " + item.userId + "] will be terminated. Are you sure?";

        let msg =
            <>
                <Alert icon={<WarningIcon fontSize="inherit" />} variant="outlined" severity="warning">
                    <div style={{ alignSelf: 'center' }}>This action cannot be undone.</div>
                </Alert>
                <Typography variant="body1" paragraph="true">
                    Are you sure you want to delete user ?
                </Typography>
                <Typography variant="body1" paragraph="true">
                    User Name: {`[${userId}]`}
                </Typography>
            </>

        let confirmProps = {
            title,
            msg,
            confirmButtonText,
            confirmCallback: () => deleteUser(companyId, userId, userStatus)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);

    }, []);

    const changeUserPermissions = useCallback((rowData) => () => {
        // console.log("change user permissions icon clicked", rowData);

        // PUT /companies/{companyId}/users/{userId}/acls?action=<ASSIGN,UNASSIGN,OVERRIDE>

        // open dialog - probably need a custom dialog

        setUserData(rowData);

        setPermissionDialogOpen(true);

    }, []);

    const toggleUserStatus = (status) => {
        if (status === 'DISABLED') {
            return 'ACTIVE';
        } else {
            return 'DISABLED';
        }
    };

    const changeUserStatus = useCallback((rowData) => () => {
        // console.log("change user status icon clicked", rowData);

        let userId = rowData.userId;
        let companyId = rowData.companyId;

        // what status the user is transitioning to. Toggle current state
        let userStatus = toggleUserStatus(rowData.userProfile.status);

        let userStatusTitle = `${userStatus === 'ACTIVE' ? 'Activate' : 'Disable'} User`;
        let userStatusButtonText = `${userStatus === 'ACTIVE' ? 'Activate' : 'Disable'}`;

        let msg =
            <>
                <Typography variant="body1" paragraph="true">
                    {`Are you sure you want to ${userStatus === 'ACTIVE' ? 'activate' : 'disable'} this user?`}
                </Typography>
                <Typography variant="body1" paragraph="true">
                    User Name: {`[${userId}]`}
                </Typography>
            </>

        let cancelButtonText = "Cancel";

        let confirmProps = {
            title: userStatusTitle,
            confirmButtonText: userStatusButtonText,
            cancelButtonText,
            msg,
            confirmCallback: () => updateUserStatus(companyId, userId, userStatus)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);

    }, []);

    const updateUserStatus = (companyId, userId, userStatus, reason) => {
        // PUT /companies/{companyId}/users/{userId}/status/{userStatus}?reason={statuc_change_reason}

        let updateStatusUrl = `/api/companies/${companyId}/users/${userId}/status/${userStatus}`;

        // not currently implemented in UI but adding if needed in the future
        if (reason) {
            updateStatusUrl += `?reason=${reason}`;
        }

        axios({
            method: "put",
            url: updateStatusUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Updated User Status [User Name: ${userId}, status: ${userStatus}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in update user status api call:', error);

                let message = `Failed to update user status [${userId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };


    const getActionButtons = (params) => {
        //let user = params.row.userId;
        let actionButtons = [];


        // create edit button
        let editButton = <GridActionsCellItem icon={
            <Tooltip title="Edit User" arrow placement="right">
                <EditIcon />
            </Tooltip>}
            label='View/Edit'
            onClick={viewEditData(params.row)}
        />;
         /* commented code for checking current user is same as logged in user*/

        // const currentUser = user.toLowerCase() === getUser().toLowerCase();

        // if(hasUsersManage || currentUser) {
        //     actionButtons.push(editButton);
        // }

        hasUsersManage && actionButtons.push(editButton);
        
        let deleteButton = <GridActionsCellItem icon={
            <Tooltip title="Delete User" arrow placement="right">
                <DeleteIcon />
            </Tooltip>}
            label='Delete'
            onClick={deleteUserData(params.row)}
        />;

        hasUsersManage && actionButtons.push(deleteButton);

        let changePermissionsButton = <GridActionsCellItem icon={
            <Tooltip title="Change Permissions" arrow placement="right">
                <ManageAccountsIcon />
            </Tooltip>}
            label='Change Permissions'
            onClick={changeUserPermissions(params.row)}
        />;

        hasUsersManage && actionButtons.push(changePermissionsButton);

        let activateButton = <GridActionsCellItem icon={
            <Tooltip title="Activate (or disable) user" arrow placement="right">
                <AccountCircleIcon />
            </Tooltip>}
            label='Activate or Disable User'
            onClick={changeUserStatus(params.row)}
        />;

        hasUsersManage && actionButtons.push(activateButton);

        return actionButtons;

    };

    const createUserData = () => {

        let rowData = {};
        const JsonData = rowData;

        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const handleJsonChange = (formData) => {
        setRowJsonData(formData);
    };

    const handleClose = () => {
        setOpen(false);

        setOpenUser(false);
    };


    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleUserPermissionsClose = () => {
        setPermissionDialogOpen(false);
        setReload(true);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    };

    const validateSchema = (userSchema, data) => {
        // console.log('got json schema', userSchema);
        const validate = ajv.compile(userSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }



    const saveUserData = (formData) => {

        // console.log('called save user:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        if (mode === 'edit') {
            if (validateSchema(userSchemaUpdate, cleanedObj)) {
                // console.log('update user schema validated successfully..');
                updateUser(cleanedObj);
            }
            else {
                console.log('update user schema validation failed..');
                let message = `Update user schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }
        }
        if (mode === 'create') {
            if (validateSchema(userSchemaRequired, cleanedObj)) {
                // console.log('create user schema validated successfully..');
                createUser(cleanedObj);

            }
            else {
                console.log('create user schema validation failed..');
                let message = `Create user schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setOpenUser(false);
        }
    }


    const updateUser = (data) => {
        try {
            // console.log('inside user update api..', data);

            let updateUrl = `/api/companies/${data.companyId}/users/${data.userId}`;

            // not sure if all is required. only firstName and lastName can be modified
            /*
            let payload = {
                createdDate: data.createdDate,
                createdUserId: data.createdUserId,
                modifiedDate: data.modifiedDate,
                modifiedUserId: data.modifiedUserId,
                companyId: data.companyId,
                userId: data.userId,
                firstName: data.userProfile.firstName,
                lastName: data.userProfile.lastName,
                status: data.userProfile.status
            };
            */
            let payload = data.userProfile;
            // console.log("update payload: ", payload);

            axios({
                method: "put",
                url: updateUrl,
                data: payload,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Updated user [${data.userId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        //setApiData([]);
                        setReload(true);

                        // console.log('got response from user update:', response);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to update user data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in update user api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to update user data `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    }

    const createUser = (data) => {
        try {
            // console.log('inside user create api..');

            let createUrl = `/api/companies/${data.companyId}/users/${data.userId}`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Created User [${response.data.userId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        //setApiData([]);
                        setReload(true);

                        // console.log('got response from user create:', response);
                        setOpen(false);
                    }

                }).catch(error => {
                    let message = `Failed to create user data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in create core document type api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to create user data `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };

    const updateUserPermissions = () => {
        // console.log("user permissions updated");

        // close dialog
        setPermissionDialogOpen(false);
    };

    return (
        <>
            <div id="userfilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={usersPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={false} totalLabel={totalLabel} tabName={'usersTab'} />
            </div>


            <Divider />

            <div id="userTableContainer" className={toggleColumnPinning()}>
                <div>
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveUserData)}
                title="User Information"
                propertiesTabContent={<UsersPropertiesPanel formId={formId}
                    mode={mode}
                    uiSchema={uiSchema}
                    userSchemaRequired={userSchemaRequired}
                    userSchemaUpdate={userSchemaUpdate}
                    saveUserData={saveUserData}
                    formData={rowJsonData} handleFormChange={handleFormChange}
                    readOnly={readOnly} />
                }
                jsonDataName="user"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />

            <ConfirmDialog
                title={confirmProps.title}
                open={confirmOpen}
                onClose={handleConfirmClose}
                setOpen={setConfirmOpen}
                cancelButtonText={confirmProps.cancelButtonText}
                confirmButtonText={confirmProps.confirmButtonText}
                onConfirm={confirmProps.confirmCallback}
            >
                {confirmProps.msg}
            </ConfirmDialog>

            <UserPermissionsDialog
                open={permissionDialogOpen}
                onClose={handleUserPermissionsClose}
                userData={userData}
                onSave={updateUserPermissions}
                setNotify={setNotify}
                setReload={setReload}
            />

        </>

    );
}

export default UserSessionsTabPanel;
